import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';

import { RffInput } from '@cast/shared-rff-ui';

export const BootDiskSection = () => (
  <InlineWithDescription
    description={
      <ControlWithDescription label="Boot disk">
        Select disk type to meet performance requirements.
      </ControlWithDescription>
    }
    controls={
      <RffInput
        name="bootDiskSizeGib"
        label="Disk size"
        type="number"
        endAdornment="GiB"
        inputProps={{
          placeholder: 'e.g. 100',
        }}
        testId="boot-disk-size-input"
      />
    }
  />
);
